<template>
  <div class="machineList">
    <List :numberRow="numberRow" :gutter="gutter">
      <div class="package_item" v-for="(item, index) in lists" :key="index" slot="Item">
        <machineItem :itemData="item" :itemType="itemType" @changeData="changeData"></machineItem>
      </div>
    </List>
  </div>
</template>

<script>
import machineItem from './machineItem.vue';
import List from '../List.vue'
export default {
  name: 'machineList',
  components: { machineItem, List },
  props: {
    numberRow: {
      type: Number,
      default: 2
    },
    gutter: {
      type: Number,
      default: 20
    },
    lists: {
      type: Array,
      default: () => ([])
    },
    //list列表 查看   op 我的分包，有底部按钮，可操作
    itemType: {
      type: String,
      default: 'list'
    },
  },
  data () {
    return {};
  },
  methods: {
    changeData () {
      this.$emit('changeData');
    }
  }
};
</script>

<style lang="scss">
.machineList {
  .package_item {
  }
}
</style>
